import jwtDecode from 'jwt-decode';
import { createAction, handleActions } from 'redux-actions';
import { Record, Map } from 'immutable';
import { pender } from 'redux-pender';

import * as api from '~/lib/api';

const LOGIN = 'session/LOGIN';

export const login = createAction(LOGIN, params => api.login(params));

const token = localStorage.getItem('token');

if (!!token) {
  try {
    const { exp } = jwtDecode(token);
    if (new Date().getTime() / 1000 > exp) {
      localStorage.removeItem('token');
    }
  } catch (ex) {
    localStorage.removeItem('token');
  }
}

const initialState = Record({
  isLoggedIn: !!token,
})();

export default handleActions(
  {
    ...pender({
      type: LOGIN,
      onSuccess: (state, { payload: response }) => {
        const token = response.data.jwt;
        const { sub: userId, login, name } = jwtDecode(token);

        window.analytics.identify(userId, {
          username: login,
          name,
        });

        localStorage.setItem('token', token);

        return state.merge(Map({ isLoggedIn: true }));
      },
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/store/modules/session.js